module.exports = __webpack_public_path__ + "media/images/default-profile-pic-004fe918c1897508b767abdaf5baf256.svg";